export default {
  numberOfProductsInFavorites: state => {
    const { favorites } = state.source

    return favorites.reduce((acc, item) => acc += item.products_count, 0)
  },
  greetingMessage: state => {
    const { title, content, footer } = state.form.greetingMessage

    return [title, content, footer].join('\n\n')
  },
  numberOfSelectedProducts: state => {
    const { selectedProducts } = state.form

    return selectedProducts.length ?? 0
  },
  priceRangeOfSelectedProducts: state => {
    const { selectedProducts } = state.form
    const prices = selectedProducts
      .filter(({ isInventory }) => !isInventory)
      .map((product) => Math.round(product.price))

    if (selectedProducts.length && !prices.length) { return 'N/A' }
    if (!prices.length) { return null }

    const min = Math.min(...prices)
    const max = Math.max(...prices)

    return `$${min} - $${max}`
  },
  requestBody: (state, getters) => {
    const { form } = state
    const { greetingMessage } = getters

    const freeFormLink = ({ successButton }) => {
      if (successButton.addButton) {
        return {
          free_form_button: successButton.buttonLabel,
          free_form_url: successButton.buttonURL,
        }
      } else {
        return {
          free_form_button: null,
          free_form_url: null,
        }
      }
    }

    return {
      name: form.name,
      greeting_message: greetingMessage,
      products: form.selectedProducts.map(({ id, sourceId, isInventory, isCollection }) => ({
        id,
        source_id: sourceId,
        source_type: isInventory ? 'inventory'
          : isCollection ? 'collection'
          : 'wishlist'
      })),
      logo_url: form.greetingMessage.logo,
      gift_giver_name: form.displayName,
      is_active: form.isActive,
      tag_ids: form.tags.map((tag) => tag.id),
      email_subject_line: form.advancedOptions.emailSubjectLine,
      email_opening_text: form.advancedOptions.emailBodyText,
      respond_to: form.advancedOptions.giftGiverEmail,
      email_button_text: form.advancedOptions.mainButtonLabel,
      cover: form.advancedOptions.cover,
      shipping: form.advancedOptions.shipping,
      video_greeting: form.advancedOptions.videoGreeting,
      enable_upgrade: form.advancedOptions.allowExchange,
      expire_after: form.advancedOptions.expirationDays,
      skip_thankyou_message: form.advancedOptions.disableThankYouNotes,
      disable_recipient_reminders: form.advancedOptions.disableReminderEmails,
      show_gift_alternatives: form.advancedOptions.disableAlternativeGifts,
      ...freeFormLink(form.advancedOptions),
    }
  },
}
